<template>
  <UDialog
    :visible="props.modelValue"
    :title="$t('auCapitals.investBlock.transactionCost')"
    @update:visible="$emit('update:modelValue', false)"
  >
    <div
      v-for="(cost, index) in costs"
      :key="index"
      class="line mt-3"
    >
      <div class="fee">
        {{ cost.label }}
      </div>
      <div class="sep" />
      <div>{{ cost.value }}</div>
    </div>
  </UDialog>
</template>

<script setup>

import UDialog from "@/components/uikit/uComponents/UDialog.vue";
import { checkPostfix } from "@/help/accessData";
import { computed } from "vue";
import { useI18n } from "@/localization/localizator";

const t = useI18n();
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  percent: {
    type: String,
    default: "1"
  }
});
const costs = computed(() => {
  return [
    { label: t(`auCapitals.costModal.label1${postfix.value}`), value: props.percent + t(`auCapitals.costModal.value1${postfix.value}`) },
    { label: t("auCapitals.costModal.label2"), value: t("auCapitals.costModal.value2") },
    { label: t("auCapitals.costModal.label3"), value: t("auCapitals.costModal.value3") },
    { label: t("auCapitals.costModal.label4"), value: t("auCapitals.costModal.value4") },
    { label: t("auCapitals.costModal.label5"), value: t("auCapitals.costModal.value5") }
  ];
});

const postfix = computed(() => {
  return checkPostfix();
});

</script>

<style scoped lang="scss">
.line {
  display: flex;
  align-items: end;

  .fee {
    color: var(--color-50);
  }

  .sep {
    height: 2px;
    flex: 1;
    border-bottom: 1px dashed var(--color-50);
    margin-bottom: 4px;
    opacity: 0.5;
  }
}
</style>